import preact, { Component } from 'preact'
import axios from 'axios'
import Portal from 'preact-portal'

class TranslationForm extends Component {
  constructor (props) {
    super()
    this.state = {
      animationClass: '',
      translation: props.translation
    }
    this.closeForm = this.closeForm.bind(this)
    this.saveNewPhrase = this.saveNewPhrase.bind(this)
    this.ref = preact.createRef()
  }
  componentDidMount () {
    this.setState({ animationClass: 'loading' }, () => {
      window.setTimeout(() => {
        this.setState({ animationClass: 'active' })
        this.ref.focus()
      }, 600)
    })
  }
  closeForm () {
    this.setState({ animationClass: '' }, () => {
      window.setTimeout(this.props.onCallback, 600)
    })
  }
  saveNewPhrase (e) {
    e.preventDefault()
    this.setState({ animationClass: 'sending' })
    axios
      .get('/phrase/edit', {
        params: {
          category: this.props.category,
          message: this.props.message,
          translation: this.state.translation
        }
      })
      .then(() => {
        this.props.onUpdate(this.state.translation)
        this.closeForm()
      })
  }
  render (props, state) {
    const { animationClass } = this.state
    const { category, message } = props

    return (
      <Portal into={'body'}>
        <form className={`live-edit__form ${animationClass}`}>
          <button type='button' onClick={this.closeForm}
            className='btn--cta btn--close icon--cross'
            title='Hide panel (<esc>)' />
          <label>
            <strong>Category</strong>
            <em>{category}</em> - <strong>Phrase</strong> <em>{message}</em>
          </label>
          <div className='live-edit__form__inputs'>
            <input
              type='text'
              ref={r => { this.ref = r }}
              value={state.translation}
              onKeyUp={(e) => this.setState({ translation: e.target.value })} />
            <button type='submit' onClick={this.saveNewPhrase}
              className='btn--cta edit__form-save' title='Save (<enter>)'>Save
            </button>
          </div>
        </form>
      </Portal>
    )
  }
}

export default TranslationForm
